import script from "./CBModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CBModal.vue?vue&type=script&setup=true&lang=js"

import "./CBModal.vue?vue&type=style&index=0&id=7110d827&scss=true&lang=css"

const __exports__ = script;

export default __exports__